/**
 * A simple handlers to create easily reducers
 * @param [Any] initialState
 * @param [Object] handlers, Object where each key is a function
 *
 * @return [Object]
 */
export default function createReducer(initialState, handlers) {
  /**
   * A handlers to
   * @param [Any] currentState, Current status for a reducer.
   * @param [Object] action
   *
   * @return [Any] New state for a reducer
   */
  return function reducer(currentState = initialState, action) {
    if (Object.prototype.hasOwnProperty.call(handlers, action.type)) {
      const reducer = handlers[action.type]

      if (reducer) return reducer(currentState, action)
    }

    return currentState
  }
}
